import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import FilterComponent from "../components/FilterInput";
import DropdownComponent from "../components/DropDown";
import axios from "axios";
import { useStore } from "../store";
import { ReactSVG } from 'react-svg';
import "./DropdownButton.css"; // Import CSS

import {
  Alert,
  Button,
  Card,
  Col,
  Container,
  Row,
  Spinner,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperclip,
  faUpload,
  faHandHoldingDollar,
  IconDefinition,
  faCalendarDays,
  faChevronDown,
  faChevronUp,
  faTag,
  faPaste,
  faLightbulb,
  faMagnifyingGlassChart,
} from "@fortawesome/free-solid-svg-icons";
import CardComponentDataSummary from "../components/CardComponentDataSummaryLida";
import CardComponentGoalsLida from "../components/CardComponentGoalsLida";
import MyForm from "../components/Form";
import Tabs from "../components/Tabs";
import VisualisationForm from "../components/VisualisationForm";
import ExplainContainer from "../components/ExplainContainer";
import InterpretContainer from "../components/InterpretContainer";
import { Colors } from "../utils/style";
import ChatContainer from "../components/ChatContainer";
import { useTranslation } from 'react-i18next';
import i18n from "../i18n";

import { axiosInstance, getUserFilesNames } from "../App";
import CreditModal from "../components/CreditModal";

type propTypes = { title?: string };

type Summary = {
  fields: {
    column: string;
    properties: {
      dtype: string;
      semantic_type: string;
      description: string;
      samples: string[];
    };
  }[];
  field_names: string[];
  categorical_fields: string[];
  boolean_fields: string[];
  numerical_fields: string[]
  file_name: string;
  name: string;
};

type Goal = {
  question: string;
  visualization: string;
  rationale: string;
};

function HomePage(props: propTypes) {
  const { visualisation, setVisualisation } = useStore();
  const { visualisation_image, setVisualisationImage } = useStore();
  const { summary, setSummary } = useStore();
  const { goals, setGoals } = useStore();

  const [showGoals, setShowGoals] = useState(true);

  const [showVisualization, setShowVisualization] = useState(true);
  const [showDataSummary, setShowDataSummary] = useState(true);

  const { selectedFileName, setSelectedFileName } = useStore();
  const [urlFileName, setUrlFileName] = useState<string>("");
  const { explanations, setExplanations } = useStore();
  const { interpretations, setIinterpretations } = useStore();
  const { userFilesNames, setUserFilesNames } = useStore();

  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [gaolsLoading, setGaolsLoading] = useState(false);
  const [visualisationLoading, setVisualisationLoading] = useState(false);
  const [uploadError, setUploadError] = useState(false);

  const [visualisationError, setVisualisationError] = useState(false);
  const { t } = useTranslation('upload');

  function getSummary(selectedFile: string) {
    const formData = new FormData();

    const body = {
      //filename: selectedFileName,
    };

    axiosInstance
      .get(
        process.env.REACT_APP_API_HOST + "summarize_user_file/" + selectedFile,

        {
          headers: {
            "Content-Type": "application/json",
            "Referrer-Policy": "no-referrer",
            Authorization: "Bearer " + localStorage.getItem("tokenLida"),
            "Accept-Language": i18n.language, // Add current language
          },
        }
      )
      .then((response) => {
        setSummary(response.data.summary);
        getGoals(selectedFile);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setUploadError(true);
        console.error("Error uploading file:", error);

        if (error.response && error.response.status === 402) {
          // Show payment modal
          setIsModalOpen(true);
        }
      });
  }

  function sendFile(selectedFile: File | null) {
    setSelectedFileName(selectedFile ? selectedFile.name : null);

    if (!selectedFile) {
      return;
    }
    setLoading(true);

    const formData = new FormData();
    formData.append("file", selectedFile);
    reinitializeAll();
    //     getSummary(selectedFile.name);

    axiosInstance
      .post(
        process.env.REACT_APP_API_HOST + "upload_save_file" + "?overwrite=true",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "Referrer-Policy": "no-referrer",
            Authorization: "Bearer " + localStorage.getItem("tokenLida"),
            "Accept-Language": i18n.language, // Add current language
          },
        }
      )
      .then((response) => {
        setLoading(false);
        getSummary(selectedFile.name);
        getUserFilesNames(setUserFilesNames);
      })
      .catch((error) => {
        setLoading(false);
        setUploadError(true);
        console.error("Error uploading file:", error);

        if (error.response && error.response.status === 402) {
          // Show payment modal
          setIsModalOpen(true);
        }
      });
  }
  function getGoals(fileName: string) {
    //   if (selectedFileName === fileName) {
    //     return; // Skip if the file name hasn't changed
    //   }

    // Update the current file name
    //   setSelectedFileName(fileName);

    // Proceed with fetching goals
    const body = {
      filename: fileName,
      n: 5,
      textgen_config: {
        temperature: 0,
        n: 1,
        model: "gpt-4o",
        max_tokens: null,
        provider: "openai",
      },
    };
    setGaolsLoading(true);
    axiosInstance
      .post(process.env.REACT_APP_API_HOST + "user_goal", body, {
        headers: {
          "Content-Type": "application/json",
          "Referrer-Policy": "no-referrer",
          Authorization: "Bearer " + localStorage.getItem("tokenLida"),
          "Accept-Language": i18n.language, // Add current language
        },
      })
      .then((response) => {
        setGoals(response.data.data);
        setGaolsLoading(false);
      })
      .catch((error) => {
        setGaolsLoading(false);
        console.error("Error uploading file:", error);

        if (error.response && error.response.status === 402) {
          // Show payment modal
          setIsModalOpen(true);
        }
      });
  }

  function reinitializeAll() {
    setSummary(null);
    setGoals(null);
    setExplanations(null);
    setIinterpretations(null);
    setVisualisationError(false);
  }

  function sendURLToGenerateSummary(url: string, fileName: string) {
    setLoading(true)
    const body = {
      url: url,
      n: 5,
      textgen_config: {
        temperature: 0,
        n: 1,
        model: "gpt-3.5-turbo-0301",
        max_tokens: null,
        provider: "openai",
      },
    };
    setSelectedFileName(fileName);
    setUrlFileName(fileName);
    reinitializeAll()
    axiosInstance
      .post(process.env.REACT_APP_API_HOST + "summarize/url", body, {
        headers: {
          "Content-Type": "application/json",
          "Referrer-Policy": "no-referrer",
          Authorization: "Bearer " + localStorage.getItem("tokenLida"),
          "Accept-Language": i18n.language, // Add current language
        },
      })
      .then((response) => {
        setSummary(response.data.summary);
        getGoals(fileName);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setUploadError(true);
        console.error("Error uploading file:", error);
      });
  }

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleDivClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
      setUploadError(false);
    }
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files ? event.target.files[0] : null;
    sendFile(selectedFile);
  };
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const exportSVG = () => {
    const blob = new Blob([visualisation], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);
    downloadFile(url, "exported_visualisation.svg");
  };

  const exportImage = (format:string) => {
    const mimeType = format === "png" ? "image/png" : "image/jpeg";
    const link = document.createElement("a");
    link.href = `data:${mimeType};base64,${visualisation_image}`;
    link.download = `exported_visualisation.${format}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadFile = (url:string, filename:string) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const uploadOptionsForDemo = [
    {
      name: "stocks.csv",
      url: "https://raw.githubusercontent.com/vega/vega-datasets/next/data/stocks.csv",
    },
    {
      name: "cars.json",
      url: "https://raw.githubusercontent.com/vega/vega-datasets/next/data/cars.json",
    },
    {
      name: "wheat.json",
      url: "https://raw.githubusercontent.com/vega/vega-datasets/next/data/wheat.json",
    },
    {
      name: "movies.json",
      url: "https://raw.githubusercontent.com/vega/vega-datasets/next/data/movies.json",
    },
    {
      name: "sp500.csv",
      url: "https://raw.githubusercontent.com/vega/vega-datasets/next/data/sp500.csv",
    },
    {
      name: "airports.csv",
      url: "https://raw.githubusercontent.com/vega/vega-datasets/next/data/airports.csv",
    },
    {
      name: "la-riots.csv",
      url: "https://raw.githubusercontent.com/vega/vega-datasets/next/data/la-riots.csv",
    },
  ];

  function onUserFilesNamesClick(fileName: string) {
    setSelectedFileName(fileName);

    setLoading(true);

    reinitializeAll();
    getSummary(fileName);
  }



  return (
    <div>
      <Container className="mt-4 mb-4">
        <div className="mb-5 mt-5">

        </div>
        <div
          className="p-3 text-center "
          onClick={handleDivClick}
          style={{
            cursor: "pointer",
            backgroundColor: "#e5e4e2",
            borderStyle: "dashed",
            borderColor: Colors.DARK_BLUE,
          }}
        >
          {/* Icon */}
          <FontAwesomeIcon
            icon={faUpload}
            size="3x"
            color={Colors.DARK_BLUE}
            className="mb-3"
          />

          {/* Your content goes here */}
          <h2 style={{ color: Colors.DARK_BLUE }}>
            {t("ClickToUpload")}
          </h2>
          <p style={{ color: Colors.DARK_BLUE }}>
            {t("UploadInstruction")}
          </p>
          {/* Hidden file input */}
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div>
        {selectedFileName && (
          <div className="mt-3">
            <FontAwesomeIcon icon={faPaperclip} />
            <strong>{t("SelectedFile")}:</strong> {selectedFileName}
          </div>
        )}
        <div className="mt-3">
          {" "}
          <p>{t("ExistingData")} </p>
        </div>
        <div className="mt-3">
          {userFilesNames?.map((fileName, index) => (
            <React.Fragment key={index}>
              <Button
                variant="light"
                className="border border-success  p-2"
                style={{ margin: "0.5rem" }}
                onClick={() => onUserFilesNamesClick(fileName)}
              >
                {fileName}
              </Button>
            </React.Fragment>
          ))}
        </div>

        <div className="mt-3">
          {" "}
          <p>{t("UseExample")} </p>
        </div>
        <div className="mt-3">
          {uploadOptionsForDemo.map((p) => (
            <Button
              variant="light"
              className="border border-success  p-2"
              style={{ margin: "0.5rem" }}
              onClick={() => sendURLToGenerateSummary(p.url, p.name)}
            >
              {p.name}
            </Button>
          ))}
        </div>

        {loading && (
          <div
            className="mt-3"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Spinner
              animation="grow"
              variant="success"
              style={{ marginRight: "0.2rem" }}
            />

            <div>
              {t("UploadingData")}
            </div>
          </div>
        )}
        {uploadError && (
                    <></>

        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "1rem",
          }}
          className="mt-3"
        >
          <FontAwesomeIcon icon={faPaste} size="2x" color={Colors.DARK_BLUE} />
          <div
            style={{
              textAlign: "left",
              fontSize: "25px",
              fontWeight: "bold",
              color: Colors.DARK_BLUE,
            }}
          >
            {t("DataSummary")}
          </div>
        </div>
        <div
          style={{
            textAlign: "left",
            fontSize: "18px",
            color: Colors.DARK_BLUE,
          }}
        >
          {
            t("DataSummaryDescription")
          }
        </div>
        {/* separator */}
        <Card
          style={{
            backgroundColor: "#e5e4e2",
          }}
          onClick={() => {
            setShowDataSummary(!showDataSummary);
          }}
          className="mt-3"
        >
          <Card.Body
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <FontAwesomeIcon
              icon={!showDataSummary ? faChevronDown : faChevronUp}
              size="1x"
            />
            <div>{summary?.dataset_description || "Data Summary"} </div>
          </Card.Body>
        </Card>
        {showDataSummary && (
          <>
            <Container className="mt-3">


              <Row md={2} xs={1} lg={3} sm={2}>
                {summary?.fields.map((d) => (
                  <Col style={{ padding: "0.5rem" }}>
                    <CardComponentDataSummary
                      title={d.column}
                      icone={undefined}
                      typeX={d.properties?.dtype || ""}
                      typeY={d.properties?.semantic_type}
                      description={d.properties?.description}
                      samples={d.properties?.samples}
                    ></CardComponentDataSummary>
                  </Col>
                ))}
              </Row>
            </Container>
          </>
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "1rem",
          }}
          className="mt-3"
        >
          <FontAwesomeIcon
            icon={faLightbulb}
            size="2x"
            color={Colors.DARK_BLUE}
          />
          <div
            style={{
              textAlign: "left",
              fontSize: "25px",
              fontWeight: "bold",
              color: Colors.DARK_BLUE,
            }}
          >
            {t("GoalExploration")}
          </div>
        </div>
        <div
          style={{
            textAlign: "left",
            fontSize: "18px",
            color: Colors.DARK_BLUE,
          }}
        >
          {
            t("GoalExplorationDescription")
          }
        </div>

        {/* separator */}
        {gaolsLoading && (
          <div
            className="mt-3"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Spinner
              animation="grow"
              variant="success"
              style={{ marginRight: "0.2rem" }}
            />

            <div>
              {t("UploadingGoals")}
            </div>
          </div>
        )}
        <Card
          style={{
            backgroundColor: "#e5e4e2",
          }}
          onClick={() => setShowGoals(!showGoals)}
          className="mt-3"
        >
          <Card.Body
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <FontAwesomeIcon
              icon={!showGoals ? faChevronDown : faChevronUp}
              size="1x"
            />
            <div>{goals ? t("Goals") + "(" + goals.length + ")" : t("Goals")} </div>
          </Card.Body>
        </Card>
        {/* end separator */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            overflow: "auto",
            gap: "1rem",
            overflowX: "auto",
            padding: "1rem",
          }}
          className="mt-3"
        >
          {showGoals &&
            goals?.map((d: Goal, index: number) => (
              <CardComponentGoalsLida
                index={index + 1}
                title={d.question}
                type={d.visualization}
                description={d.rationale}
              ></CardComponentGoalsLida>
            ))}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "1rem",
          }}
          className="mt-3"
        >
          <FontAwesomeIcon
            icon={faMagnifyingGlassChart}
            size="2x"
            color={Colors.DARK_BLUE}
          />
          <div
            style={{
              textAlign: "left",
              fontSize: "25px",
              fontWeight: "bold",
              color: Colors.DARK_BLUE,
            }}
          >
            {t("VisualizationGeneration")}
          </div>
        </div>
        <div
          style={{
            textAlign: "left",
            fontSize: "18px",
            color: Colors.DARK_BLUE,
          }}
        >
          {
            t("VisualizationGenerationDescription")
          }
        </div>
        {/* separator */}
        {gaolsLoading && (
          <div
            className="mt-3"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Spinner
              animation="grow"
              variant="success"
              style={{ marginRight: "0.2rem" }}
            />

            <div>
              {t("UploadingVisualization")}
            </div>
          </div>
        )}
        <Card
          style={{
            backgroundColor: "#e5e4e2",
          }}
          onClick={() => setShowVisualization(!showVisualization)}
          className="mt-3"
        >
          <Card.Body
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <FontAwesomeIcon
              icon={!showVisualization ? faChevronDown : faChevronUp}
              size="1x"
            />
            <div>{"Visualization Generation"} </div>
          </Card.Body>
        </Card>
        {/* end separator */}
        {summary && (
          <div
            style={{
              display: "flex",
              justifyItems: "center",
              justifyContent: "center",
            }}
          >
            <VisualisationForm
              summary={summary}
              setVisualisationLoading={setVisualisationLoading}
              setVisualisationError={setVisualisationError}
              buttonText={t("GenerateButton")}
            />
          </div>
        )}
        {visualisationLoading && (
          <div
            className="mt-3"
            style={{
              display: "flex",
              alignItems: "center",
              height: "20rem",
              justifyContent: "center",
              fontSize: "18px",
              gap: "2rem",
            }}
          >
            <Spinner
              animation="grow"
              variant="success"
              style={{ marginRight: "0.2rem" }}
            />

            <div>
              {t("GeneratingVisualization")}
            </div>
          </div>
        )}
        {visualisationError && (
          <></>
        )}
        {visualisation != "" && !visualisationLoading && (
          <>

              <div
               style={{cursor: "pointer"}}>
                <ReactSVG
                    src={`data:image/svg+xml;utf8,${encodeURIComponent(visualisation)}`}
                    beforeInjection={(svg) => {
                      svg.setAttribute('style', 'width: 100%; height: auto;');
                    }}
                    renumerateIRIElements={false}
                    wrapper="div"
                    onClick={() =>
                                {
//                         setModalOpen(true)
                                }
                            } // Open the modal on click
                />
               </div>
                   {/* Export Button */}
                   <div style={{ position: "relative", display: "inline-block" }} ref={dropdownRef}>

      <button
        onClick={() => {setIsOpen(!isOpen);
        }}
        style={{
          padding: "10px 20px",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          cursor: "pointer",
          borderRadius: "5px",
        }}
      >
        Export ▼
      </button>
      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: "0",
            backgroundColor: "white",
            border: "1px solid #ddd",
            borderRadius: "5px",
            boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
            zIndex: 1000,
            width: "150px",
          }}
        >
          <button
            onClick={exportSVG}
            style={{
              display: "block",
              width: "100%",
              padding: "10px",
              backgroundColor: "white",
              border: "none",
              textAlign: "left",
              cursor: "pointer",
              color: "#333",
            }}
          >
            Export as SVG
          </button>
          <button
            onClick={() => exportImage("png")}
            style={{
              display: "block",
              width: "100%",
              padding: "10px",
              backgroundColor: "white",
              border: "none",
              textAlign: "left",
              cursor: "pointer",
              color: "#333",
            }}
          >
            Export as PNG
          </button>
          <button
            onClick={() => exportImage("jpeg")}
            style={{
              display: "block",
              width: "100%",
              padding: "10px",
              backgroundColor: "white",
              border: "none",
              textAlign: "left",
              cursor: "pointer",
              color: "#333",
            }}
          >
            Export as JPEG
          </button>
        </div>
      )}
    </div>

            <Card className="mt-3" data-bs-theme="dark">
              <Card.Body>
                {summary && (
                  <Tabs
                    content_1={
                      <div
                        style={{
                          display: "flex",
                          justifyItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <MyForm
                          summary={summary}
                          setVisualisationLoading={setVisualisationLoading}
                          setVisualisationError={setVisualisationError}
                          buttonText={t("RefineButton")}
                        />
                      </div>
                    }
                    content_2={<ExplainContainer />}
                    content_3={<InterpretContainer />}
                    content_4={
                      <ChatContainer
                        fileName={
                          (selectedFileName && selectedFileName) || urlFileName
                        }
                      />
                    }
                  ></Tabs>
                )}
              </Card.Body>
            </Card>
          </>
        )}
      </Container>

    </div>
  );
}

export default HomePage;
